export const customV20 = [
  {
    name: 'customV2_startPageV4',
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'customV2_age',
  },
  {
    name: 'customV2_breed',
  },
  // {
  //   name: 'customV2_health',
  // },
  // {
  //   name: 'customV2_food',
  // },
  {
    name: 'customV2_info_breed',
  },
  {
    name: 'customV2_potty_v2',
  },
  {
    name: 'potty_how_long',
  },
  {
    name: 'potty_where',
  },
  {
    name: 'potty_how_often_walks',
  },
  {
    name: 'potty_health_issues',
  },
  {
    name: 'potty_where_want',
  },
  {
    name: 'info_about_potty',
  },
  {
    name: 'customV2_issues',
  },
  {
    name: 'customV2_walking_issues',
  },
  {
    name: 'training_raise_voice',
  },
  {
    name: 'training_react_to_punishment',
  },
  {
    name: 'customV2_training_time',
  },
  {
    name: 'customV2_training',
  },
  {
    name: 'customV2_creating_program',
  },
  {
    name: 'customV2_plan',
  },
  {
    name: 'customV2_email',
  },
];
